/**
 * Pawsy: local carousel bootstrap.
 *
 * The clone's three carousels (image grid, testimonial slider, video carousel)
 * were driven by section scripts hotlinked to the source site's CDN. Offline
 * those fetches are blocked by CORS, so Swiper never initialises and the
 * serialised slide transforms are left frozen - slides sit off-canvas at
 * negative x on desktop and overflow the viewport on mobile, and lazy images
 * inside them never decode.
 *
 * swiper.min.js IS local and sets window.Swiper, so we initialise the three
 * containers ourselves rather than copying any more of the source site's code.
 */
(function () {
  var CONFIGS = [
    { sel: '.swiper.benefits-swiper', opts: { slidesPerView: 1.15, spaceBetween: 12, breakpoints: { 990: { slidesPerView: 3, spaceBetween: 16 } } } },
    { sel: '.swiper.ts-review-swiper', opts: { slidesPerView: 1.05, spaceBetween: 12, breakpoints: { 990: { slidesPerView: 3, spaceBetween: 20 } } } },
    { sel: '.video-carousel .swiper',  opts: { slidesPerView: 1.4,  spaceBetween: 12, breakpoints: { 990: { slidesPerView: 4.5, spaceBetween: 12 } } } },
  ];

  function clearFrozenState(root) {
    // Remove the transform/width the live site serialised into the markup, so
    // Swiper measures a clean layout instead of inheriting an old scroll offset.
    var w = root.querySelector('.swiper-wrapper');
    if (w) { w.style.transform = ''; w.style.transitionDuration = ''; }
    root.querySelectorAll('.swiper-slide').forEach(function (s) {
      s.style.width = ''; s.style.marginRight = '';
    });
    root.classList.remove('swiper-initialized', 'swiper-backface-hidden');
  }

  function init() {
    if (!window.Swiper) return false;
    CONFIGS.forEach(function (c) {
      document.querySelectorAll(c.sel).forEach(function (el) {
        if (el.dataset.pawsySwiper) return;
        try {
          clearFrozenState(el);
          var opts = Object.assign({ watchOverflow: true, observer: true, observeParents: true }, c.opts);
          new window.Swiper(el, opts);
          el.dataset.pawsySwiper = '1';
        } catch (e) {
          console.warn('[pawsy] swiper init failed for', c.sel, e);
        }
      });
    });
    // lazy images inside slides only decode once laid out
    document.querySelectorAll('.swiper img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    return true;
  }

  window.addEventListener('pawsy:swiper-ready', init);
  if (!init()) {
    var tries = 0;
    var t = setInterval(function () { if (init() || ++tries > 60) clearInterval(t); }, 100);
  }
})();
